import { Component, Input, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { VerticalTabListModel } from 'src/app/model';

@Component({
  selector: 'app-vertical-tab-list',
  templateUrl: './vertical-tab-list.component.html',
  styleUrls: ['./vertical-tab-list.component.css']
})
export class VerticalTabListComponent {
  @Input()
  set list(value: VerticalTabListModel[]) {
    this._list = value;
    this.selectedItem = value?.[0]?.name;
  }

  get list() {
    return this._list;
  }

  @Output() tabClick = new Subject<VerticalTabListModel>();

  selectedItem: string;

  private _list: VerticalTabListModel[];

  constructor() {}

  /**
   * Lists selected item
   * @param item,
   */
  onTabClick(item: VerticalTabListModel): void {
    this.selectedItem = item?.name;
    this.tabClick.next(
      this.list?.find((element) => element?.name === item?.name)
    );
  }
}
